import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { RoundedPlusIcon } from "../../../../ui/icons/RoundedPlusIcon"
import { TrashIcon } from "../../../../ui/icons/trash"
import Button from "../../../../ui/molecules/button"
import { PopupForm } from "../../../../ui/organisms/popupForm"
import { ContoTerziPopupAdd } from "./popup"
import { GetAllNotThirdParty, GetAllNotThirdPartyProcessing, GetAllNotThirdPartyStructure, resetCreateRequest, resetCreateStatus } from "./slice"
import { activityOptions, FilieraOptions, optionsFormatter, ProcessingActivityOptions } from "../../../../utils"

export function ContoTerziLists() {
    const dispatch = useAppDispatch()
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const thirdPartyState = useAppSelector(state => state.notificationThirdParty)
    const notificationState = useAppSelector(state => state.notification)

    useEffect(() => {
        dispatch(GetAllNotThirdParty({ itemsPerPage: 0, page: 0, notificationId: notificationState.notificationIdToUpdate }))
        dispatch(GetAllNotThirdPartyProcessing({ itemsPerPage: 0, page: 0, notificationId: notificationState.notificationIdToUpdate }))
        dispatch(GetAllNotThirdPartyStructure({ itemsPerPage: 0, page: 0, notificationId: notificationState.notificationIdToUpdate }))
    }, [])

    useEffect(() => {
        if (thirdPartyState.creationProcessingStatus === 'successfully') {
            setShowPopup(false)
            dispatch(GetAllNotThirdPartyProcessing({ itemsPerPage: 0, page: 0, notificationId: notificationState.notificationIdToUpdate }))
            dispatch(resetCreateRequest())
            dispatch(resetCreateStatus())
        }
    }, [thirdPartyState.creationProcessingStatus])

    return (
        <div style={{ padding: '24px' }}>
            <table id="users-table" className="w-[100%] mb-10">
                <thead className="h-[52px] uppercase">
                    <tr>
                        <th style={{ borderTopLeftRadius: '8px' }}></th>
                        <th className="width-[130px]">Cod. Fiscale C/Terzi</th>
                        <th className="width-[130px]">Regione</th>
                        <th className="width-[100px]">Provincia</th>
                        <th className="width-[130px]">Comune</th>
                        <th className="width-[130px]">Indirizzo</th>
                        <th className="width-[130px]">Recapiti</th>
                        <th className="width-[130px]">Telefono</th>
                        <th className="width-[130px]">Odc</th>
                        <th className="width-[130px]">Attività</th>
                        <th className="width-[130px]">Fonte Dato</th>
                        <th className="width-[130px]" style={{ borderTopRightRadius: '8px', width: '40px' }}>Assoggettato</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        thirdPartyState.getAllNotThirdPartyResponse?.data.map((c, index) =>
                            <tr
                                key={index}
                                style={{
                                    color: '#4D797F',
                                    background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                }}
                            >
                                <td></td>
                                <td>{c.fiscalCode}</td>
                                <td>{c.region}</td>
                                <td>{c.province}</td>
                                <td>{c.city}</td>
                                <td>{c.address}</td>
                                <td>{c.contact}</td>
                                <td>{c.phone}</td>
                                <td>{c.odc}</td>
                                <td>{c.activity}</td>
                                <td>{c.dataSource}</td>
                                <td>{c.addicted}</td>
                            </tr>
                        )}
                </tbody>
            </table>

            <table id="users-table" className="w-[100%] mb-10">
                <thead className="h-[52px] uppercase">
                    <tr>
                        <th style={{ borderTopLeftRadius: '8px' }}></th>
                        <th className="width-[130px]">N. UP</th>
                        <th className="width-[130px]">Attività</th>
                        <th className="width-[130px]">Cod. Belfiore</th>
                        <th className="width-[130px]">Sez.</th>
                        <th className="width-[130px]">Foglio</th>
                        <th className="width-[130px]">Particella</th>
                        <th className="width-[130px]">Sub</th>
                        <th className="width-[130px]">Indirizzo</th>
                        <th className="width-[130px]">Possesso</th>
                        <th className="width-[130px]">Utilizzo</th>
                        <th className="width-[130px]">Superfice</th>
                        <th className="width-[130px]" style={{ borderTopRightRadius: '8px', width: '40px' }}>Metodo</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        thirdPartyState.getAllNotThirdPartyStructureResponse?.data.map((s, index) =>
                            <tr
                                key={index}
                                style={{
                                    color: '#4D797F',
                                    background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                }}
                            >
                                <td></td>
                                <td>{s.productiveUnitNumber}</td>
                                <td>{s.activity}</td>
                                <td>{s.cadastralCode}</td>
                                <td>{s.section}</td>
                                <td>{s.sheet}</td>
                                <td>{s.parcel}</td>
                                <td>{s.sub}</td>
                                <td>{s.address}</td>
                                <td>{s.ownership}</td>
                                <td>{s.usage}</td>
                                <td>{s.area}</td>
                                <td>{s.method}</td>
                            </tr>
                        )}
                </tbody>
            </table>

            <table id="users-table" className="w-[100%] mb-5">
                <thead className="h-[52px] uppercase">
                    <tr>
                        <th style={{ borderTopLeftRadius: '8px' }}></th>
                        <th className="width-[130px]">Unità Produttiva</th>
                        <th className="width-[20%]">CUAA Terzista</th>
                        <th className="width-[100px]">Filiera</th>
                        <th className="width-[130px]">Acitivity</th>
                        <th className="width-[130px%]">Classificazione</th>
                        <th className="width-[130px]" style={{ borderTopRightRadius: '8px', width: '40px' }}>Escludi Stampa</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        thirdPartyState.getAllNotThirdPartyProcessingResponse?.data.map((k, index) =>
                            <tr
                                key={index}
                                style={{
                                    color: '#4D797F',
                                    background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                }}
                            >
                                <td>
                                    <div style={{ display: 'flex', gap: '6px' }}>
                                        <button onClick={() => { }}>
                                            <TrashIcon color="red" size={20} />
                                        </button>
                                    </div>
                                </td>
                                <td>{k.productiveUnit}</td>
                                <td>{k.cuaa}</td>
                                <td>{optionsFormatter(k.production, FilieraOptions)}</td>
                                <td>{optionsFormatter(k.activity, ProcessingActivityOptions)}</td>
                                <td>{k.classification}</td>
                                <td>
                                    {
                                        k.noPrinting && (
                                            <span>Si</span>
                                        )
                                    }
                                    {
                                        !k.noPrinting && (
                                            <span>No</span>
                                        )
                                    }
                                </td>
                            </tr>
                        )}
                </tbody>
            </table>

            <div style={{ display: 'flex', gap: '24px', justifyContent: 'flex-end' }}>
                <Button
                    variant="solid"
                    color="dimgrey"
                    iconPosition="left"
                    icon={<RoundedPlusIcon />}
                    size="md"
                    label="Aggiungi attività"
                    onClick={() => setShowPopup(true)}
                />
            </div>

            {
                showPopup && (
                    <PopupForm headerGreen title="Aggiungi attività" close={() => setShowPopup(false)}>
                        <ContoTerziPopupAdd close={() => setShowPopup(false)} />
                    </PopupForm>
                )
            }
        </div>
    )
}